module.exports = __webpack_public_path__ + "img/sicily.7db1f869.svg";